interface ICompressImageProps {
	url: string;
	format?: string;
	width: number | string;
}

function compressImage({ url, width, format }: ICompressImageProps): string {
	if (format) return `https://compressor.amigoedu.com.br?url=${url}&format=${format}&width=${width}`;

	return `https://compressor.amigoedu.com.br?url=${url}&width=${width}`;
}

export { compressImage };
